// extracted by mini-css-extract-plugin
export default {"label":"quantity__label__jOFUa","button":"quantity__button__F88Gv","disabled":"quantity__disabled__JO6Mz","value":"quantity__value__VA9sV","subtract":"quantity__subtract__bGRvT"};